import { ListEntry, ListModel } from '../../list-builder/model/list.model';

export class SampleList extends ListModel {
    constructor(
        public createdBy?: string,
        public selectionVariableId?: number,
        public instanceIds?: string[],
        public takenBy?: string,
        public samplingDate?: string,
        public datasetId?: number,
        public cropName?: string,
        public programUUID?: string,
        public parentId?: number,
        public createdDate?: string,
        public notes?: string,
    ) {
        super();
    }
}

export class SampleListEntry extends ListEntry {
    constructor(
        public sampleId?: number,
        public sampleNumber?: number
    ) {
        super();
    }
}
